/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
export const addOnBeforeUnloadListener = (onBeforeUnload: () => void) => {
  window.addEventListener('beforeunload', onBeforeUnload);
};

export const removeOnBeforeUnloadListener = (onBeforeUnload: () => void) => {
  window.removeEventListener('beforeunload', onBeforeUnload);
};

export const addOnScrollListener = (el: Element, onScrollFn: () => void) => {
  el && el.addEventListener('scroll', onScrollFn);
};

export const removeOnScrollListener = (el: Element, onScrollFn: () => void) => {
  el && el.removeEventListener('scroll', onScrollFn);
};
